import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getMGMDetails } from '../../selectors/mgmSelectors';
import MobileInviteBanner from '../../components/MobileInviteBanner';
import {
  trackInviteBannerClose,
  trackInviteBannerClick,
  trackInviteBannerVisit,
} from '../../actions/tracking/sharing';
import { showInviteModal } from '../../actions/inviteActions';
import i18n from '../../utils/i18n';

export class MobileInviteBannerContainer extends React.Component {
  state = {
    isDesktopWidth: true,
    isDismissed: false,
  };

  componentDidMount() {
    const DESKTOP_MIN = 768;
    this.mediaQuery = window.matchMedia(`(min-width: ${DESKTOP_MIN}px)`);
    this.handleMediaChange(this.mediaQuery);

    this.mediaQuery.addListener(this.handleMediaChange);

    this.props.trackInviteBannerVisit();
  }

  componentWillUnmount() {
    this.mediaQuery.removeListener(this.handleMediaChange);
  }

  handleMediaChange = (mq) => {
    this.setState({ isDesktopWidth: !!mq.matches });
  };

  onClose = () => {
    this.setState({ isDismissed: true });
    this.props.trackInviteBannerClose();
  };

  onClick = () => {
    this.props.showInviteModal();
    this.props.trackInviteBannerClick();
    this.setState({ isDismissed: true });
  };

  getBodyText() {
    const { referrerSteps, inviteeSteps } = this.props;

    if (referrerSteps && inviteeSteps) {
      return i18n.gettext('mgm.inviteStepped.mobileBanner.body');
    }

    return i18n.gettext('mgm.invite.mobileBanner.body');
  }

  getLinkText() {
    const { referrerAmount, referrerSteps, inviteeSteps } = this.props;

    if (referrerSteps && inviteeSteps) {
      return i18n.gettext('mgm.inviteStepped.mobileBanner.link(%(amount)s)', {
        amount: referrerAmount,
      });
    }

    return i18n.gettext('mgm.invite.mobileBanner.link(%(amount)s)', {
      amount: referrerAmount,
    });
  }

  render() {
    const { isDismissed, isDesktopWidth } = this.state;

    if (isDesktopWidth) return null;

    return (
      <MobileInviteBanner
        isDismissed={isDismissed}
        bodyText={this.getBodyText()}
        linkText={this.getLinkText()}
        onClose={this.onClose}
        onClick={this.onClick}
      />
    );
  }
}

MobileInviteBannerContainer.propTypes = {
  referrerAmount: PropTypes.string.isRequired,
  referrerSteps: PropTypes.number,
  inviteeSteps: PropTypes.number,
  trackInviteBannerClose: PropTypes.func.isRequired,
  trackInviteBannerClick: PropTypes.func.isRequired,
  trackInviteBannerVisit: PropTypes.func.isRequired,
  showInviteModal: PropTypes.func.isRequired,
};

MobileInviteBannerContainer.defaultProps = {
  referrerSteps: undefined,
  inviteeSteps: undefined,
};

const mapStateToProps = (state) => {
  const { referrerAmount, referrerSteps, inviteeSteps } = getMGMDetails(state);

  return {
    referrerAmount,
    referrerSteps,
    inviteeSteps,
  };
};

const mapDispatchToProps = (dispatch) => ({
  trackInviteBannerClose: () => dispatch(trackInviteBannerClose()),
  trackInviteBannerClick: () => dispatch(trackInviteBannerClick()),
  trackInviteBannerVisit: () => dispatch(trackInviteBannerVisit()),
  showInviteModal: () => dispatch(showInviteModal()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MobileInviteBannerContainer);
